import { BaseService } from '../../../../core/base/base.service';
import { GenericEquipmentModel } from '../../../../core/models/generic-equipment.model';
import { HttpClient } from '@angular/common/http';
import { GenericAdditionalCostModel } from '../../../../core/models/generic-additional-cost.model';
import { AuthService } from '../../../../core/services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenericAdditionalCostService extends BaseService<GenericAdditionalCostModel> {
  defaultSort = 'label';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-additional-cost', authService);
  }
}
